<template>
  <iframe
    id="ai-chat"
    :src="src"
    class="h-[calc(100vh-100px)] w-full tablet:h-[580px]"
  />
</template>

<script setup lang="ts">
import { DomainId } from '#graphql-operations'

const { isProduction, activeDomain } = useSiteContext()

const src = computed(() => {
  const id = isProduction
    ? '649d6f4c8b725442ebaa6faa'
    : '66a8971690fa3c4ae4a369a1'
  return `https://concierge.goodguys.ai/client/${id}/overlay`
})

useHead({
  script: [
    {
      key: 'goodguys-client',
      src:
        activeDomain === DomainId.rapperswil_zuerichsee_ch
          ? 'https://concierge.goodguys.ai/client/6569e0d7eea26b4665ec8ad0/ai_concierge.js'
          : 'https://concierge.goodguys.ai/client/649d6f4c8b725442ebaa6faa/ai_concierge.js',
      async: true,
    },
  ],
})
</script>
